const errorSeparator = '^^'

const ERROR_MAPPING = {
  'The file is locked, only read operations are allowed': 'FolderIsLocked',
  'Cannot lock folder because it has an active magic link': 'cannotLockWithMagicLink',
  'searchTimeout': 'searchTimeout'
  // ... add other backend errors
}

export function parseError (error) {
  let message = getErrorMessage(error)
  const errorData = message.split(errorSeparator)
  let params = {}
  if (errorData.length > 1) {
    message = errorData[0]
    params.errorData = errorData[1]
  }
  if (error.details) {
    params = error.details
  }

  let match = false
  if (message && typeof message === 'string') {
    for (const [backendMsg, translationKey] of Object.entries(ERROR_MAPPING)) {
      if (message.includes(backendMsg)) {
        message = translationKey
        match = true
        break
      }
    }
  }

  return {
    message,
    params,
    match
  }
}

function getErrorMessage (error) {
  if (typeof error !== 'object') {
    return error
  }

  if (error.body && error.body.error) {
    return error.body.error
  }

  if (error.data && error.data.error) {
    return error.data.error
  }

  if (error.message) {
    return error.message
  }

  if (error.error) {
    return error.error
  }

  return error
}



// WEBPACK FOOTER //
// ./src/error/parser.js